import { Tags } from '~/api/everest/tags.autogen';

/**
 * Shared tag constants/builders for the everest RTK api, used both inside
 * `enhancements.ts` and by consumers that need to invalidate a cache entry
 * imperatively from outside a hook (e.g. a sibling component reacting to an
 * action taken elsewhere, or a still-unmigrated `api` endpoint that used to
 * invalidate the same data before the migration).
 */
export const TICKET_CURRENT_STAGE_TAG = {
  type: Tags.tickets,
  id: 'CURRENT_STAGE',
} as const;
export const TICKET_ACTIVITY_LOG_TAG = {
  type: Tags.tickets,
  id: 'ACTIVITY_LOG',
} as const;
export const TICKET_SUMMARY_TAG = {
  type: Tags.tickets,
  id: 'TICKET_SUMMARY',
} as const;
export const TICKET_CURRENT_VERSION_TAG = {
  type: Tags.tickets,
  id: 'CURRENT_VERSION',
} as const;
export const TICKET_PARTICIPANTS_TAG = {
  type: Tags.tickets,
  id: 'PARTICIPANTS',
} as const;
export const PERMISSIONS_LIST_TAG = {
  type: Tags.permissions,
  id: 'LIST',
} as const;

export const TURN_TRACKING_LIST_TAG = {
  type: Tags.turn_tracking,
  id: 'LIST',
} as const;

export const packageEnvelopeTag = (ticketId: string) => ({
  type: Tags.packages,
  id: `envelope:${ticketId}`,
});
export const packageRecipientsTag = (ticketId: string) => ({
  type: Tags.packages,
  id: `recipients:${ticketId}`,
});
export const packageActivitiesTag = (ticketId: string) => ({
  type: Tags.packages,
  id: `activities:${ticketId}`,
});
